(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('stockTransfer', {
        templateUrl: 'views/components/views/stockTransfer/stockTransfer.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'stockTransferService', 'rememberService', 'dbPrinterService', '$uibModal', 'ieScreenBlockService', 'ttGridFactory', 'layoutService', function ($stateParams, stateService, utilityService, translateService, modalService, stockTransferService, rememberService, dbPrinterService, $uibModal, ieScreenBlockService, ttGridFactory, layoutService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let stockTransferKeyno = $stateParams.stocktransfer_keyno;

            let variableNames = {
                //bg_stocktransfer_function: '',
                printer: ''
            };

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                confirm_print_ok: '',
                confirmation: '',
                error: '',
                ok: '',
                stocktransferload_pick_finished: ''
            };

            vm.model = {
                bgMain: {
                    selected: 'FUNCTION',
                    buttons: [
                        { id: 'FUNCTION', label: 'bg_main_function', color: 'primary', onClick: () => vm.model.bgMain.selected = 'FUNCTION' },
                        { id: 'DETAILS', label: 'bg_main_details', color: 'primary', onClick: () => vm.model.bgMain.selected = 'DETAILS' }
                    ]
                },
                bgStockTransferFunction: {
                    selected: 'LOAD',
                    buttons: [
                        { id: 'LOAD', label: 'bg_stocktransfer_load', color: 'primary', onClick: () => setStockTransferFunctionView('LOAD') },
                        { id: 'UNLOAD', label: 'bg_stocktransfer_unload', color: 'primary', onClick: () => setStockTransferFunctionView('UNLOAD') },
                        { id: 'PLACED', label: 'bg_stocktransfer_placed', color: 'primary', onClick: () => setStockTransferFunctionView('PLACED') }
                    ]
                },
                menu: {},
                tabletSize: layoutService.getMediaQueries().tablet,
                loadGridReady: false,
                itemsListLoaded: [],
                itemsListUnloaded: [],
                itemsListPlaced: [],
                selectListPrinters: [],
                lockedPrint: false,
                lockedPickFinished: false,
                lockedUnloadFinished: false,
                lockedUnloadAll: false,
                lockedDelete: false
                
            };

            vm.loadGrid = new ttGridFactory({
                rememberId: 'stocktransfer.loadgrid',
                kendo: {
                    height: '100%',
                    sortable: true,
                    aggregate: true,
                    pager: false,
                    selectable: false,
                    filterable: false
                }
            }).setConfig({
                rowClick: true
            }).setOptionFunc(
                onRowClick
            ).setToolbar({
                buttons: [
                    {
                        name: 'stocktransferload_pick_finished',
                        text: 'stocktransferload_pick_finished',
                        func: () => vm.pickFinishedChanges(vm.model.menu),
                        icon: 'fa-arrow-to-bottom',
                        cssClass: 'btn tt-button--success im-grid-btn-xs-r',
                        read_on_close: false,
                        spinOnAction: true,
                        translate: true,
                        disabled: vm.model.lockedPickFinished
                    }
                ]
            });

            function onRowClick(e) {
                if (e?.data?.func === 'CellClickHandler') {
                    stockTransferService.getP2PortalUserVariableSetWs('consignment_prepick_special_product', e.data?.clickedCell?.dataItem?.['special_product'] ?? '').then(function () {
                        stateService.go('stocktransferloaditem', e.data.clickedCell?.dataItem?.['parms']);
                    });
                }
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            // #region BUTTON RADIO FUNCTIONS

            function setStockTransferFunctionView(id) {
                vm.model.bgStockTransferFunction.selected = vm.model.menu.bg_stocktransfer_function = id;
            }

            // #endregion BUTTON RADIO FUNCTIONS

            // #region LOAD PROCEDURE CALLS
            
            async function loadMenu() {
                vm.model.menu = (await stockTransferService.getMenu({ stocktransfer_keyno: stockTransferKeyno }))[0];
                
                setStockTransferFunctionView(vm.model.menu.bg_stocktransfer_function);

                vm.model.printer = vm.model.menu.p2_printer_keyno;
                
                loadStockTransferLoaded();
                loadUnloaded();

                if (vm.model.bgStockTransferFunction.selected === 'PLACED') loadPlaced();
    		}

            async function loadPrinters() {
                vm.model.selectListPrinters = await dbPrinterService.list();
            };

            async function loadStockTransferLoaded() {
                vm.model.itemsListLoaded = await stockTransferService.listLoaded(vm.model.menu);
    		}
            
            async function loadUnloaded() {
                vm.model.itemsListUnloaded = await stockTransferService.listUnloaded(vm.model.menu);
            }

            async function loadPlaced() {
                vm.model.itemsListPlaced = await stockTransferService.listPlaced(vm.model.menu);
            }

            async function loadLoadGrid() {
                if (vm.model.menu?.datatask_load_grid === '0') return; // Ingen plukkliste

                vm.loadGrid.dataTask.loadData = {
                    method: vm.model.menu.datatask_load_grid,
                    parameters: vm.model.menu
                };

                vm.model.loadGridReady = true;

                if (vm.loadGrid.gridfunc !== null) vm.loadGrid.gridfunc.read();
            }

            // #endregion LOAD PROCEDURE CALLS

            vm.pickFinishedChanges = function () {
                vm.model.lockedPickFinished = true;

                stockTransferService.pickFinishedObj(vm.model.menu).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedPickFinished = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedPickFinished = false;
                        setStockTransferFunctionView('UNLOAD');
                    }
                });
            };

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'stockTransferLoad':
                        if (vm.model.menu.stocktransfertype_keyno === '12') {
                            state = 'stocktransferloaditem';

                            go({
                                stocktransfer_keyno: vm.model.menu.stocktransfer_keyno,
                                stock_keyno: '0',
                                stockbatch_keyno: '0',
                                stocklocation_keyno_from: '0',
                                quantity: '0.00'
                            });
                        } else {
                            state = 'stocktransferload';

                            go({ stocktransfer_keyno: vm.model.menu.stocktransfer_keyno });
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region UNLOAD FINISHED BUTTON FUNCTION
            
            vm.unloadFinishedChanges = function () {
                vm.model.lockedUnloadFinished = true;

                stockTransferService.unloadFinishedObj(vm.model.menu).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedUnloadFinished = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedUnloadFinished = false;
                        stateService.back();
                    }
    			});
            };

            // #endregion UNLOAD FINISHED BUTTON FUNCTION

            // #region UNLOAD ALL BUTTON FUNCTION

            vm.unloadAllChanges = function () {
                vm.model.lockedUnloadAll = true;

                stockTransferService.unloadAllObj(vm.model.menu).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedUnloadAll = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedUnloadAll = false;
                        stateService.back();
                    }
                });
            };

            // #endregion UNLOAD ALL BUTTON FUNCTION

            // #region PRINTING FUNCTION

            vm.onPrinterChanged = function (value) {
                vm.model.printer = value;

                if (value) {
                    rememberFunc('printer');
                }
            };

            // #endregion PRINTING FUNCTION

            // #region BUTTON PRINT PROCEDURE FUNCTION CALL

            vm.printLabels = function () {
                vm.model.lockedPrint = true;

                const modalRef = $uibModal.open({
                    animation: true,
                    backdrop: 'static',
                    component: 'ttConfirm',
                    resolve: {
                        message: function () {
                            return translations.confirm_print_ok;
                        }
                    }
                });

                modalRef.result.then((confirmed) => {
                    if (confirmed !== true) {
                        vm.model.lockedPrint = false;
                        return;
                    }

                    ieScreenBlockService.start();

                    stockTransferService.printLabelTrolley({
                        stocktransfer_keyno: vm.model.menu.stocktransfer_keyno,
                        p2_printer_keyno: vm.model.printer
                    }).then((response) => {
                        ieScreenBlockService.stop();

                        if (response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'danger',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-danger',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                        vm.model.lockedPrint = false;
                                    }
                                }]
                            });
                        } else {
                            modalService.show({
                                type: 'success',
                                title: translations.confirmation,
                                message: 'Done',
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-success',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                        vm.model.lockedPrint = false;
                                    }
                                }]
                            });
                        }
                    });
                });
            }

            // #endregion BUTTON PRINT PROCEDURE FUNCTION CALL

            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            function rememberFunc(id) {
                Object.keys(variableNames).forEach((key) => {
                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
                });

                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

                let variableValue = null;

                switch (id) {
                    case 'bg_stocktransfer_function':
                        if (utilityService.validateParmsValue(vm.model.menu[id]) !== true) return;

                        variableValue = vm.model.menu[id];
                    case 'printer':
                        if (utilityService.validateParmsValue(`${vm.model.printer}`) !== true) return;

                        variableValue = vm.model.printer;
                        break;
                    default:
                        break;
                }

                return rememberService.remember(variableNames[id], variableValue);
            }

            // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    stockTransferService.deleteItem({ stocktransfer_keyno: vm.model.menu.stocktransfer_keyno }).then((response) => {
                        if (response[0] && response[0].errorcode !== '0') {
                        	modalService.show({
                        		type: 'warning',
                        		title: translations.error,
                        		message: response[0].errormessage,
                        		buttons: [{
                        			label: translations.ok,
                        			cssClass: 'btn-warning',
                        			action: function (dialogItself) {
                        				dialogItself.close();
                        				vm.model.lockedDelete = false;
                        			}
                        		}]
                        	});
                        } else {
                        	vm.model.lockedDelete = false;
                        	stateService.back();
                        }
                    }, () => {
                        vm.model.lockedDelete = false;
                    });
                }, () => {
                    vm.model.lockedDelete = false;
                });
            };

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region BUTTON RADIO FUNCTIONS

            vm.selectBgMain = function (value) {
                vm.model.bgMain.selected = value;
            };

            vm.selectBgStockTransferFunction = function (value) {
                vm.model.bgStockTransferFunction.selected = value;
                vm.model.menu.bg_stocktransfer_function = vm.model.bgStockTransferFunction.selected;

                //rememberFunc('bg_stocktransfer_function');

                if (vm.model.bgStockTransferFunction.selected === 'PLACED') loadPlaced();
            };

            // #endregion BUTTON RADIO FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                loadPrinters();
                await loadMenu();
                loadLoadGrid();
            };

            // #endregion ON INIT FUNCTION

        }]
    });
})();
